import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import $ from 'jquery';
import { PredicateList } from '@bingads-webui/predicate-list';
import editorTemplate from './template/index.pug';

export class FilterEditor extends Backbone.View {
  get events() {
    return {
      'click .apply': 'apply',
      'click .cancel': 'cancel',
    };
  }

  initialize(options) {
    this.options = options;

    const newName = ko.observable();
    const isSaving = ko.observable();
    newName.subscribe((val) => {
      isSaving(!!val.trim());
    });

    if (this.options.selected && this.options.selected.name) {
      newName(this.options.selected.name);
    } else {
      newName('');
    }

    this.ko_model = _.extend({}, this.options.ko_model, {
      newName,
      isSaved: isSaving,
      hasNameError: ko.computed(() => isSaving() &&
        (_.isUndefined(newName()) || _.isEmpty(newName().trim()))),
    });
  }

  render() {
    const $layout = $(editorTemplate({
      headerTitle: this.options.i18n.getString('Filter'),
      nameWaterMarkTitle: this.options.i18n.getString('Filter_FilterNameWaterMark'),
      applyTitle: this.options.i18n.getString('Apply'),
      cancelTitle: this.options.i18n.getString('Cancel'),
      saveFilter: this.options.i18n.getString('Filters_SaveFilter'),
    }));
    const $listContainer = $layout.find('.list-placeholder');

    if (!!this.options.predicateList && !!this.options.predicateList.Constructor) {
      this.predicateList =
        new this.options.predicateList.Constructor(_.extend(
          this.options,
          this.options.predicateList.options || {},
          {
            el: $listContainer[0],
          }
        ));
    } else {
      this.predicateList = new PredicateList(_.extend({}, this.options, {
        el: $listContainer,
      }));
    }

    const viewModel = _.extend({
      canApply: ko.computed(() => this.predicateList.ko_model.canApply() &&
        !this.ko_model.hasNameError(), this),
    }, this.ko_model);

    this.$el.html($layout);
    ko.applyBindings(viewModel, this.el);
    this.predicateList.render();
    return this;
  }

  show() {
    this.$el.show();
    return this;
  }

  hide() {
    this.$el.hide();
    return this;
  }

  remove() {
    this.predicateList.remove();
    ko.cleanNode(this.el);
    this.$el.empty();
    this.undelegateEvents();
    return this;
  }

  apply() {
    const filterQuery = this.predicateList.getFilterQuery();
    this.trigger('apply', filterQuery, this.ko_model.isSaved() ? this.ko_model.newName() && this.ko_model.newName().trim() : null);
  }

  clean() {
    this.ko_model.newName('');
    this.predicateList.clean();
  }

  cancel() {
    this.clean();
    this.hide();
    this.trigger('cancel');
  }
}
